import { watch } from 'vue';
import { NO_ENROLL_FEE } from '@/globals/constants';
import { hasAnnouncementText } from '@/globals/announcements.js';

const ENROLLMENT_PATH = '/panel-de-control/inscribirse';

export const runAuthRedirect = ({
  router,
  route,
  user,
  store,
  globalAnnouncements,
}) => {
  if (!router || !route || !user) {
    return false;
  }

  const hasUserId = Boolean(user && user.id);
  const isAuthRoute = Boolean(route && route.meta && route.meta.auth);
  const isEnrollmentRoute = route && route.path === ENROLLMENT_PATH;
  const hasUnpaidEnrollment = user?.fees?.enrollment === 'unpaid';

  if (!(hasUserId && isAuthRoute && !isEnrollmentRoute && hasUnpaidEnrollment)) {
    return false;
  }

  if (store) {
    const announcements = globalAnnouncements || [];
    const hasNoEnrollFeeAnnouncement = hasAnnouncementText(
      announcements,
      NO_ENROLL_FEE,
    );
    if (!hasNoEnrollFeeAnnouncement) {
      store.dispatch('addGlobalAnnouncement', {
        text: NO_ENROLL_FEE,
        type: 'warn',
      });
    }
  }

  router.replace({ path: ENROLLMENT_PATH });
  return true;
};

export const useAuthRedirect = ({
  router,
  getRoute,
  getUser,
  store,
  getGlobalAnnouncements,
}) => {
  if (!router || !getRoute || !getUser) {
    return () => {};
  }

  return watch(
    () => {
      const route = getRoute();
      const user = getUser();
      return [user && user.id, route && route.path, route && route.meta && route.meta.auth];
    },
    () => {
      runAuthRedirect({
        router,
        route: getRoute(),
        user: getUser(),
        store,
        globalAnnouncements: getGlobalAnnouncements ? getGlobalAnnouncements() : [],
      });
    },
    { immediate: true },
  );
};
